import OfflineWarningBanner from "molecules/alerts/offline-warning-banner";
import AccountSubscriptionInfoBanner from "organisms/alerts/account-subscription-info-banner";
import React from "react";
import useNetworkInformation from "utilities/contexts/network-information/use-network-information";
import useAiChatEnabled from "utilities/hooks/use-ai-chat-enabled";
import TryCasiBanner from "./try-casi-banner";

const UserDashboardBanners = () => {
    const { isOnline } = useNetworkInformation();
    const { useAIChat } = useAiChatEnabled();
    const showCasiBanner = useAIChat;
    return (
        <>
            {isOnline && showCasiBanner && <TryCasiBanner />}
            {!isOnline && <OfflineWarningBanner />}
            <AccountSubscriptionInfoBanner />
        </>
    );
};

export default UserDashboardBanners;
